    $('.country-flags').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
      responsive: [   {
      breakpoint: 641,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    }]
    });


 $('.industry-part').slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
    dots: true,
        autoplaySpeed: 5000,
        responsive: [   {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        }
      }]


    });
 $('.left-vertical').slick({
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            vertical: true,
            verticalSwiping: true,
            autoplay: true,
            autoplaySpeed: 5000

        });


 $(document).ready(function () {

        // Select and loop the container element of the elements you want to equalise
        $('#workslider').each(function () {

            // Cache the highest
            var highestBox = 0;

            // Select and loop the elements you want to equalise
            $('.tr_slider_div .work-content p', this).each(function () {

                // If this box is higher than the cached highest then store it
                if ($(this).height() > highestBox) {
                    highestBox = $(this).height();
                }

            });

            // Set the height of all those children to whichever was highest 
            $('.tr_slider_div .work-content p', this).height(highestBox);

        });

    });
    $(".work-slider").slick({ slidesToShow: 1, slidesToScroll: 1, arrows: !0, fade: !0, dots: !1, adaptiveHeight: !1 });
    // $(".pagingInfo").on("init reInit afterChange", function (e, t, o, i) {
    // (o = (o || 0) + 1), $status.text(o + "/" + t.slideCount);
    // }),


 jQuery(document).ready(function () { jQuery(".mbtnext").click(function () { jQuery(".slick-next.slick-arrow").click() }), jQuery(".mbtprevious").click(function () { jQuery(".slick-prev.slick-arrow").click() }) });